import { styled } from 'styled-components';

export const StyledDeletedUserBadge = styled.div`
	padding: 4px 6px;
	font-size: 12px;
	font-style: italic;
	color: #525259;
	background: #dae4e8;
	border-radius: 4px;
	white-space: nowrap;
`;
